import { useContext } from 'react'
import GoogleGeoJSON from '../googleMap/geoJson'
import MapboxGeoJSON from '../mapbox/geoJson'
import { MapContext } from './mapContext'
import {
  FeatureCollectionWithInfoAndStyle,
  FeatureWithInfoAndStyle,
  InfoAndStyle,
} from '~/components/mapContent/utils/geoAndStatsToFeatureCollection'

interface GeoJSONProps {
  geoJson: FeatureCollectionWithInfoAndStyle
  idPropertyName?: string
  renderInfoWindow?: (props: { feature: FeatureWithInfoAndStyle }) => JSX.Element
  onClick?: (
    event: google.maps.Data.MouseEvent | mapboxgl.MapMouseEvent,
    feature: FeatureWithInfoAndStyle | undefined,
  ) => void
}

export default function GeoJSON<T>(props: GeoJSONProps) {
  const mapContext = useContext(MapContext)
  if (!mapContext) {
    throw new Error('GeoJSON must be used within a map')
  }

  const { mapProvider } = mapContext

  let layerJSXElement: JSX.Element
  if (mapProvider === 'google') {
    layerJSXElement = (
      <GoogleGeoJSON {...props} onClick={event => props.onClick?.(event, undefined)} />
    )
  } else if (mapProvider === 'mapbox') {
    layerJSXElement = <MapboxGeoJSON {...props} />
  } else {
    throw new Error(`Unsupported map provider: ${mapProvider}`)
  }

  return layerJSXElement
}
